import React, { useState } from 'react';
import './HomeFAQ.css';

const FAQ_DATA = [
  {
    id: 1,
    question: 'Dudas Generales',
    type: 'list',
    answers: [
      { q: '¿Todos los itinerarios son gratuitos?', a: 'Todos nuestros itinerarios y cursos son completamente gratuitos.' },
      { q: '¿Entregan certificado?', a: 'Tecno3F entrega certificados al finalizar los cursos.' },
      { q: '¿Necesito conocimientos previos?', a: 'La mayoría de los cursos no requiere ningún tipo de conocimiento previo. En el caso de necesitarlos, estará indicado en los requerimientos.' },
      { q: '¿Cuál es la diferencia entre un curso y un itinerario?', a: 'Un itinerario está conformado por diferentes cursos, al mismo tiempo cada curso tiene un orden determinado que deberás seguir para poder avanzar en tu aprendizaje.' },
    ],
  },
  {
    id: 2,
    question: 'Dudas sobre la Inscripción',
    type: 'text',
    answer: 'El proceso de inscripción es muy sencillo. Solo necesitás crear una cuenta, seleccionar el curso de tu interés y completar el formulario. Una vez confirmada la inscripción, tendrás acceso al contenido.',
  },
  {
    id: 3,
    question: 'Dudas sobre los Itinerarios',
    type: 'text',
    answer: 'Nuestros itinerarios están cuidadosamente diseñados por expertos en cada área. Cada curso tiene una duración estimada y podés avanzar a tu propio ritmo. Incluyen materiales, ejercicios prácticos y evaluaciones.',
  },
];

const HomeFAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (id) => {
    setOpenItems((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="home-faq">
      <div className="home-faq-container">
        <div className="home-faq-header">
          <p className="home-faq-mini">PREGUNTAS FRECUENTES</p>
          <h2>Preguntas Frecuentes</h2>
        </div>
        <div className="home-faq-list">
          {FAQ_DATA.map((item) => (
            <div key={item.id} className="home-faq-item">
              <button
                type="button"
                className="home-faq-question"
                onClick={() => toggleItem(item.id)}
              >
                <span className="home-faq-question-text">{item.question}</span>
                <span className={`home-faq-icon ${openItems[item.id] ? 'rotated' : ''}`}>
                  {openItems[item.id] ? '−' : '+'}
                </span>
              </button>
              <div className={`home-faq-answer ${openItems[item.id] ? 'open' : ''}`}>
                <div className="home-faq-answer-content">
                  {item.type === 'list' ? (
                    <div className="home-faq-answers-list">
                      {item.answers.map((qa, index) => (
                        <div key={index} className="home-faq-qa">
                          <h4>{qa.q}</h4>
                          <p>{qa.a}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>{item.answer}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeFAQ;
